import { useEffect } from "react";

const InfoPage = ({ eyebrow, title, intro, updated, children, testId }) => {
  useEffect(() => {
    window.__lenis ? window.__lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
  }, []);

  return (
    <section className="max-w-3xl mx-auto px-6 pt-36 pb-32" data-testid={testId}>
      <p className="text-[10px] tracking-[0.4em] uppercase text-[#C07C5F] mb-6">{eyebrow}</p>
      <h1 className="font-serif-lux font-medium text-5xl md:text-6xl tracking-tighter leading-[0.95] mb-8">{title}</h1>
      {intro && <p className="text-sm md:text-base font-light text-[#5C5C5C] leading-relaxed mb-6">{intro}</p>}
      {updated && (
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#5C5C5C] mb-6">Last updated — {updated}</p>
      )}
      <div className="border-t border-[#EBE8E3] pt-12 flex flex-col gap-12">{children}</div>
    </section>
  );
};

export const InfoSection = ({ heading, children }) => (
  <div>
    <h2 className="font-serif-lux text-2xl md:text-3xl font-medium tracking-tight mb-4">{heading}</h2>
    <div className="text-sm font-light text-[#5C5C5C] leading-relaxed flex flex-col gap-3">{children}</div>
  </div>
);

export default InfoPage;
